:host {
  display: block;
  width: 100%;
  @include cms-components-host-defaults;
  --cms-text-color: var(--cms-semanticColors-base-strong-text);
}

:host*,
:host*::before,
:host*::after {
  box-sizing: border-box;
}

.showroom-container-inner {
  @include cms-default-grid-container;
}

.showroom-container-inner > * {
  grid-area: var(--cms-default-grid-area);
}

.showroom-img-wrapper {
  position: relative;
  cursor: pointer;
}

.open-overlay-wrapper {
  line-height: px-to-rem(30);
  position: absolute;
  right: var(--cms-spacing-100);
  text-align: right;
  top: var(--cms-spacing-100);
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.open-overlay-text {
  background: var(--cms-semanticColors-transparency-medium-background);
  border-radius: var(--cms-border-radius-special);
  display: flex;
  align-items: center;
  height: var(--cms-spacing-200);
  padding-right: var(--cms-spacing-300);
  color: var(--cms-semanticColors-transparency-medium-textOnBackground);
  margin: 0 var(--cms-spacing-100) 0 var(--cms-spacing-025);
  padding-left: var(--cms-spacing-100);
  @include label-font-100;
}

.open-overlay-icon {
  box-sizing: border-box;
  background-color: var(--cms-semanticColors-primary-background);
  border: var(--cms-border-size-xs) solid var(--cms-semanticColors-primary-background);
  border-radius: var(--cms-border-radius-half);
  color: var(--cms-semanticColors-primary-textOnBackground);
  font-family: arial;
  font-size: var(--cms-spacing-200);
  height: var(--cms-spacing-200);
  line-height: var(--cms-spacing-200);
  position: absolute;
  right: var(--cms-spacing-075);
  text-align: center;
  top: 0;
  width: var(--cms-spacing-200);
  display: flex;
  align-items: center;
  justify-content: center;
}

cms-product-card {
  padding: var(--cms-spacing-100);
  --cms-article-data-grid-area-override: auto / auto / auto / span 12;
  --cms-article-image-grid-area-override: auto / 2 / auto / span 10;
  --cms-article-grid-gap-override: var(--cms-spacing-100);
  --cms-article-grid-padding-override: 0;
}

@include media-width($breakpoint-sm) {
  cms-product-card {
    --cms-article-data-grid-area-override: auto / auto / auto / span 8;
    --cms-article-image-grid-area-override: auto / auto / auto / span 4;
  }
}

@include media-width($breakpoint-md) {
  cms-product-card {
    --cms-article-data-grid-area-override: auto / auto / auto / span 10;
    --cms-article-image-grid-area-override: auto / auto / auto / span 2;
  }
}

.articles-container-inner {
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);
  color: var(--cms-semanticColors-base-strong-text);
  background: var(--cms-semanticColors-container-weak-background);
}


.responsive-gradient-border {
  background: #fff;
  background: linear-gradient(to bottom, #fff 0%, #e5e5e5 100%);
  display: block;
  height: px-to-rem(10);
  width: 100%;
  margin-top: px-to-rem(10);
}

.article-cta-button {
  width: 100%;
}

@include media-width($breakpoint-sm) {
  .two-thirds {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }
}
